import { render, staticRenderFns } from "./TodoButton.vue?vue&type=template&id=31de18c2&"
import script from "./TodoButton.vue?vue&type=script&lang=js&"
export * from "./TodoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports